import { getUrlWithStoredParams } from "@/components/Routing/redirectFromLoader";
import { getSessionStorageValue } from "@/hooks/useLocalStorage";

import type { PortfolioRouteParams } from "../../routes";

export const PORTFOLIO_OVERVIEW_FILTER_STORAGE_KEY = "portfolio-overview-filters";

export type PersistedPortfolioOverviewFilters = Pick<PortfolioRouteParams["overview"], "startDate">;

/**
 * The Portfolio Overview URL with the reporting period stored earlier in this tab, when the URL has none. The route
 * loader redirects there before the page renders, so the widgets only query the stored period.
 */
export function getStoredPortfolioOverviewPeriodUrl(url: URL): string | undefined {
  const stored = getSessionStorageValue<PersistedPortfolioOverviewFilters>(PORTFOLIO_OVERVIEW_FILTER_STORAGE_KEY, {});

  return getUrlWithStoredParams(url, ["startDate"], { startDate: stored.startDate });
}
